<template lang="pug">
  b-modal#updateCMLT(
    ref="updateCMLT"
    :title="$t('ui.combine.update_commission')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    size="md"
    @ok="done"
    @show="reset"
    @shown="shown"
    :hide-footer="!$helpers.getVisible(editLimit)"
  )
    b-form(novalidate :disabled="!submission.success" @submit.stop.prevent="submit")
      span #[b {{ $t("ui.account_id") + " : " + accountId.toUpperCase() }}]
      #tblModal.table-sm.table-responsive.commission
        table.table.table-bordered
          tbody
            tr(v-show="false")
              th {{ comm_lottery_1d_title }}
              td
                PTSelect(
                  ref="comm_lottery_1d"
                  :dirty="$v.comm_lottery_1d.$dirty"
                  :error="$v.comm_lottery_1d.$error"
                  :options="comm_lottery_1d_options"
                  v-model="$v.comm_lottery_1d.$model"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
            tr(v-show="false")
              th {{ comm_lottery_2d_title }}
              td
                PTSelect(
                  ref="comm_lottery_2d"
                  :dirty="$v.comm_lottery_2d.$dirty"
                  :error="$v.comm_lottery_2d.$error"
                  :options="comm_lottery_2d_options"
                  v-model="$v.comm_lottery_2d.$model"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
            tr
              th {{ comm_lottery_3d_title }}
              td
                PTSelect(
                  ref="comm_lottery_3d"
                  :dirty="$v.comm_lottery_3d.$dirty"
                  :error="$v.comm_lottery_3d.$error"
                  :options="comm_lottery_3d_options"
                  v-model="$v.comm_lottery_3d.$model"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
            tr
              th {{ comm_lottery_4d_title }}
              td
                PTSelect(
                  ref="comm_lottery_4d"
                  :dirty="$v.comm_lottery_4d.$dirty"
                  :error="$v.comm_lottery_4d.$error"
                  :options="comm_lottery_4d_options"
                  v-model="$v.comm_lottery_4d.$model"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
      .form-group
        b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import config from "@/config";
import { required, maxValue } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import PTSelect from "@/library/PTSelect";

export default {
  components: {
    PTSelect,
    SubmitButton
  },
  props: {
    accountId: ""
  },
  data() {
    return {
      loading: false,
      comm_lottery_1d: 0,
      comm_lottery_2d: 0,
      comm_lottery_3d: 0,
      comm_lottery_4d: 0,
      submission: {
        success: true,
        status: ""
      }
    }
  },
  validations: {
    comm_lottery_1d: {
      required,
      maxValue(value) {
        return maxValue(this.comm_lottery_1d_max)(value)
      }
    },
    comm_lottery_2d: {
      required,
      maxValue(value) {
        return maxValue(this.comm_lottery_2d_max)(value)
      }
    },
    comm_lottery_3d: {
      required,
      maxValue(value) {
        return maxValue(this.comm_lottery_3d_max)(value)
      }
    },
    comm_lottery_4d: {
      required,
      maxValue(value) {
        return maxValue(this.comm_lottery_4d_max)(value)
      }
    }
  },
  computed: {
    editLimit: function() {
      return [config.accessRoles.editLimit]
    },
    comm_lottery_1d_title: function() {
      return this.$t("ui.lottery_1d") + " (" + this.comm_lottery_1d_max + ")"
    },
    comm_lottery_1d_max: function() {
      if(this.$store.getters.getCommLT){
        return this.$store.getters.getCommLT[0].one_d
      }
    },
    comm_lottery_1d_options: function() {
      return this.$helpers.getCommRateList1(this.comm_lottery_1d_max, this.comm_lottery_1d)
    },
    comm_lottery_2d_title: function() {
      return this.$t("ui.lottery_2d") + " (" + this.comm_lottery_2d_max + ")"
    },
    comm_lottery_2d_max: function() {
      if(this.$store.getters.getCommLT){
        return this.$store.getters.getCommLT[0].two_d
      }
    },
    comm_lottery_2d_options: function() {
      return this.$helpers.getCommRateList1(this.comm_lottery_2d_max, this.comm_lottery_2d)
    },
    comm_lottery_3d_title: function() {
      return this.$t("ui.lottery_3d") + " (" + this.comm_lottery_3d_max + ")"
    },
    comm_lottery_3d_max: function() {
      if(this.$store.getters.getCommLT){
        return this.$store.getters.getCommLT[0].three_d
      }
    },
    comm_lottery_3d_options: function() {
      return this.$helpers.getCommRateList1(this.comm_lottery_3d_max, this.comm_lottery_3d)
    },
    comm_lottery_4d_title: function() {
      return this.$t("ui.lottery_4d") + " (" + this.comm_lottery_4d_max + ")"
    },
    comm_lottery_4d_max: function() {
      if(this.$store.getters.getCommLT){
        return this.$store.getters.getCommLT[0].four_d
      }
    },
    comm_lottery_4d_options: function() {
      return this.$helpers.getCommRateList1(this.comm_lottery_4d_max, this.comm_lottery_4d)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault()
      this.submit()
    },
    getChildCommission: function() {
      $("select").prop("disabled", !this.$helpers.getVisible(this.editLimit))
      let account_id = this.accountId
      let platform_code = "LOTTERY"
      if(account_id) {
        this.$store
        .dispatch("user/getChildCommission", { account_id, platform_code })
        .then(response => {
          this.$v.comm_lottery_1d.$model = response.data.cm[0].one_d
          this.$v.comm_lottery_2d.$model = response.data.cm[0].two_d
          this.$v.comm_lottery_3d.$model = response.data.cm[0].three_d
          this.$v.comm_lottery_4d.$model = response.data.cm[0].four_d
          $("select").prop("disabled", !this.$helpers.getVisible(this.editLimit))
        })
        .catch(response => {
        });
      } else {
        this.cancel()
      }
    },
    submit: function() {
      // this.reset()
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.update_account_commission_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            this.updateCommLT()
          } else if (
            // Read more about handling dismissals
            result.dismiss === 'cancel'
          ) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.update_account_commission_cancel"),
              type: "error",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        });
      }
    },
    updateCommLT: function() {
      let account_id = this.accountId
      let one_d = this.comm_lottery_1d
      let two_d = this.comm_lottery_2d
      let three_d = this.comm_lottery_3d
      let four_d = this.comm_lottery_4d
      this.$store
        .dispatch("user/updateCommissionLT", { account_id, one_d, two_d, three_d, four_d })
        .then(response => {
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if(this.submission.success == true) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.succeed"),
              text: this.$t("message.update_account_commission_success"),
              type: "success",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        })
        .catch(response => {
          // console.log("Failed:updateCommissionLT", response)
          this.loading = false;
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    reset: function() {
      this.submission.success = true
      this.submission.status = ""
      this.comm_lottery_1d = 0
      this.comm_lottery_2d = 0
      this.comm_lottery_3d = 0
      this.comm_lottery_4d = 0
    },
    shown: function() {
      this.$nextTick(() => {
        this.$v.$reset()
        this.$helpers.getCommission()
        this.getChildCommission()
      });
    },
    cancel: function() {
      // this.$emit("clicked")
      this.$refs.updateCMLT.hide()
    }
  }
};
</script>

